"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSubscriptionProgramError = void 0;
const common_1 = require("@twurple/common");
/**
 * Thrown whenever you try accessing a subscription-related resource
 * such as {@ChannelApi#getChannelSubscriptions}
 * and the given channel does not have a subscription program.
 */
class NoSubscriptionProgramError extends common_1.CustomError {
    /** @private */
    constructor(channelId) {
        super(`Channel ${channelId} does not have a subscription program`);
    }
}
exports.NoSubscriptionProgramError = NoSubscriptionProgramError;
